import React, { useState } from 'react';

import { Arrow } from 'icons/untitledui';

import * as Text from 'theme/components/Text.style';
import * as Styled from 'priorities/styles/PrioritySection.style';

export interface PrioritySectionProps {
  title: string;
  count: number;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  collapseAriaLabel: string;
  expandAriaLabel: string;
}

export default function PrioritySection({
  title,
  count,
  children,
  defaultExpanded = true,
  collapseAriaLabel,
  expandAriaLabel,
}: PrioritySectionProps): JSX.Element {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const contentId = `priority-section-${title
    .replace(/\s+/g, '-')
    .toLowerCase()}`;

  return (
    <Styled.Section data-testid="priority-section">
      <Styled.Header
        type="button"
        aria-expanded={expanded}
        aria-controls={contentId}
        aria-label={expanded ? collapseAriaLabel : expandAriaLabel}
        onClick={() => setExpanded((prev) => !prev)}
      >
        <Text.H5 as="h2">{`${title} (${count})`}</Text.H5>
        <Styled.Chevron $expanded={expanded} aria-hidden>
          <Arrow.ChevronUp />
        </Styled.Chevron>
      </Styled.Header>
      {expanded && <Styled.Body id={contentId}>{children}</Styled.Body>}
    </Styled.Section>
  );
}
